import type { RunDetailResponse } from "contracts/api/crawl/run-read.responses";
import { Show } from "solid-js";
import { SeverityBadge } from "../../ui/Badge";
import { relativeAge } from "../../ui/format";
import {
  runFindingAction,
  runFindingSummary,
  runFindingTitle,
} from "./runPresentation";

export function RunFindingRow(props: {
  finding: RunDetailResponse["findings"][number];
}) {
  const finding = () => props.finding;
  return (
    <li>
      <SeverityBadge severity={finding().severity} />{" "}
      <strong>{runFindingTitle(finding())}</strong>
      <div>{runFindingSummary(finding())}</div>
      <Show when={runFindingAction(finding())}>
        {(action) => <div>Action: {action()}</div>}
      </Show>
      <details class="run-technical-detail">
        <summary>Technical detail</summary>
        <dl>
          <div>
            <dt>Original generated detail</dt>
            <dd>{finding().detail}</dd>
          </div>
          <Show when={finding().recommendedAction}>
            {(action) => (
              <div>
                <dt>Original generated recommendation</dt>
                <dd>{action()}</dd>
              </div>
            )}
          </Show>
          <div>
            <dt>Source</dt>
            <dd class="mono">
              {finding().url} / {finding().metricKey} /{" "}
              {relativeAge(finding().createdAt)}
            </dd>
          </div>
        </dl>
      </details>
    </li>
  );
}
